import type { HoursPayOutRequestResponse } from 'generated/index';

export enum HoursPayOutAction {
  PAY_OUT = 'PAY_OUT',
  REJECT = 'REJECT'
}

/**
 * The most requests one action may cover, matching `maxItems` on the approve and reject request
 * schemas. Processing is one call and one transaction, and paying out awaits a whole-year hours
 * recalculation per employment on the shared hours-management service, so the batch has to stay
 * bounded: those run four employments at a time, and the approve call itself has to finish inside
 * the 60s event-bus timeout. The selection is capped here rather than split over several calls,
 * because splitting would put part of a bulk through while the planner is told the action failed.
 *
 * The grid's page sizes are kept at or below this: a page the planner can fill but not action in one
 * go is a trap.
 */
export const MAX_REQUESTS_PER_ACTION = 25;

/** A grid row: the response plus the two fields the overview derives from it. */
export interface HoursPayOutRequestRow extends HoursPayOutRequestResponse {
  remainingInMinutes: number | null;
  disableSelection: boolean;
}
